import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const supportJourneyRoutes = [
  {
    id: 'support-view-support-home',
    trackingName: 'Support View Support Home',
    path: 'dl/view/support-home',
    loader: async ({ context }) => {
      context?.browserNavigate('/support')
    },
  },
  {
    id: 'support-view-support-topic',
    trackingName: 'Support View Support Topic',
    path: 'dl/view/support/:support_node_token',
    loader: async ({ context, params }) => {
      const topic = params['support_node_token']
      context?.browserNavigate(`/support/${topic}`)
    },
  },
  {
    id: 'support-view-support',
    trackingName: 'Support View Support',
    path: 'dl/view/support',
    loader: async ({ context }) => {
      context?.browserNavigate('/support')
    },
  },
] as const satisfies JourneyRoute[]
